import { Vista } from "@essenza/react";
import { useModel, useVista, useGraph } from "@essenza/react";
import { useEffect} from "react";
import { useLocation } from "react-router-dom";
import { CandidateModel, JobModel } from "../models/jobmodel";
import { CandidateList } from "../view/CandidateList";

export function CandiateVistaVistaController(c) {
    c.skin = CandiateVista;
    let store = null;
    c.command = {
    }
}

export function CandiateVista(info) {
    const [ctx, control] = useVista(CandiateVistaVistaController);
    const [model] = useModel();
    const candidate = useGraph(CandidateModel, "candidates");
    const job = useLocation().state;
    useEffect(() => {
        console.log("MODEL ", model);
        if (model) {
            model.read(CandidateModel, m => m.candidates(job.id));
        }
    }, [model, job.id]);

    console.log("CANDIDATE-LIST-VISTA");

    return (
        <Vista context={ctx} >
            <div className="w100 py-md">
                <div className="centered max-width text-center">
                  <h1><span className="pointer mx-md" onClick={()=>control.navigate(-1)}>&lt;</span>Elenco Candidati
                  { job && <span> {job.title} <p className="h8 py-sm"> {job.contract}-{job.place}</p></span>}
                  </h1>
                    <CandidateList column job={job} source={candidate?.get()} />
                </div>
            </div>
        </Vista>
    )
}